export default __webpack_public_path__ + "static/media/bg4.f73edbe7.jpg";